module.exports = __webpack_public_path__ + "img/service-setting-item4.8fdce4c7.png";